import {AuthenticationProvider} from "@/modules/shared/bridges/AuthenticationProvider";
import {MasterDataRepository} from "@/modules/masterData/adapter/MasterDataRepository";
import {ServiceClient} from "@/modules/shared/ServiceCall";

export class MasterDataRestRepository implements MasterDataRepository {
    private readonly auth: AuthenticationProvider;
    private readonly service: ServiceClient;
    private masterDataList= [{
        "LABEL" : "Warengruppen",
        "ICON" : "posmanager-types",
        "GRIDNAME" : "BROWSE_WARENGRUPPEN",
        "FORMNAME" : "",
        "DISABLED" : false,
        "ACTIONS" : [],
        "MULTISELECTACTIONS" : []
    },
        {
            "LABEL" : "Verkaufspersonal",
            "ICON" : "posmanager-users-man-woman",
            "GRIDNAME" : "BROWSE_VERKAUFSPERSONAL",
            "FORMNAME" : "",
            "DISABLED" : false,
            "ACTIONS" : [],
            "MULTISELECTACTIONS" : []
        },
        {
            "LABEL" : "Preiskategorien",
            "ICON" : "posmanager-tag-price-euro",
            "GRIDNAME" : "BROWSE_PREISKATEGORIEN",
            "FORMNAME" : "",
            "DISABLED" : false,
            "ACTIONS" : [],
            "MULTISELECTACTIONS" : []
        },
        {
            "LABEL" : "Kundentypen",
            "ICON" : "posmanager-people-customers",
            "GRIDNAME" : "BROWSE_KUNDENTYPEN",
            "FORMNAME" : "",
            "DISABLED" : false,
            "ACTIONS" : [],
            "MULTISELECTACTIONS" : []
        },
        {
            "LABEL" : "Bestandslisten",
            "ICON" : "ordermanager-storage-shelves",
            "GRIDNAME" : "BROWSE_BESTANDSLISTEN",
            "FORMNAME" : "",
            "DISABLED" : false,
            "ACTIONS" : [],
            "MULTISELECTACTIONS" : []
        },
        {
            "LABEL" : "Artikel-Einheiten",
            "ICON" : "posmanager-settings",
            "GRIDNAME" : "BROWSE_EINHEITEN",
            "FORMNAME" : "",
            "DISABLED" : false,
            "ACTIONS" : [],
            "MULTISELECTACTIONS" : []
        },
        {
            "LABEL" : "Allergene",
            "ICON" : "posmanager-danger",
            "GRIDNAME" : "BROWSE_ALLERGENE",
            "FORMNAME" : "",
            "DISABLED" : false,
            "ACTIONS" : [],
            "MULTISELECTACTIONS" : []
        },
        {
            "LABEL" : "EAN13-Konfigurationen",
            "ICON" : "posmanager-label-barcode-settings",
            "GRIDNAME" : "BROWSE_EAN13KONFIGURATIONEN",
            "FORMNAME" : "",
            "DISABLED" : false,
            "ACTIONS" : [],
            "MULTISELECTACTIONS" : []
        },
        {
            "LABEL" : "Texte",
            "ICON" : "posmanager-label-text-font",
            "GRIDNAME" : "BROWSE_ETIKETTENTEXTE",
            "FORMNAME" : "",
            "DISABLED" : false,
            "ACTIONS" : [],
            "MULTISELECTACTIONS" : []
        },
        {
            "LABEL" : "Tara-Werte",
            "ICON" : "posmanager-settings",
            "GRIDNAME" : "BROWSE_TARAS",
            "FORMNAME" : "",
            "DISABLED" : false,
            "ACTIONS" : [],
            "MULTISELECTACTIONS" : []
        },
        {
            "LABEL" : "Rabatte",
            "ICON" : "posmanager-coupon",
            "GRIDNAME" : "BROWSE_WAAGENRABATTE",
            "FORMNAME" : "",
            "DISABLED" : false,
            "ACTIONS" : [],
            "MULTISELECTACTIONS" : []
        },
        {
            "LABEL" : "Zahlungsmittel",
            "ICON" : "posmanager-payment-method-card",
            "GRIDNAME" : "BROWSE_ZAHLUNGSMITTEL",
            "FORMNAME" : "",
            "DISABLED" : false,
            "ACTIONS" : [],
            "MULTISELECTACTIONS" : []
        }
    ];

    // Modul heißt masterData, die Endpunkte liegen aber unter /POSManager
    public async del_BestandslistenArtikel(id:number,ids:number[]): Promise<void> {
        await this.service.call('del_BestandslistenArtikel',
            { Bestandsliste: id, Artikelnummern: ids });
    }

    public async set_BestandslistenArtikel(id:number,ids:number[]): Promise<void> {
        await this.service.call('set_BestandslistenArtikel',
            { Bestandsliste: id, Artikelnummern: ids });
    }

    private toSelected(entries: any[]): any[] {
        return entries.map((e) => ({NUMMER: e.id}));
    }
    public static masterDataItems: any[];

    constructor(auth: AuthenticationProvider) {
        this.auth = auth;
        // nicht als Feld-Initializer: this.auth ist zu dem Zeitpunkt noch undefined
        this.service = new ServiceClient(auth, 'POSManager');
    }

    public getGridList(): any[] {
        const sid = this.auth.getAuthToken();

        if (sid) {
            const tabs = [];
            const apiTabs = this.masterDataList;
            for (let i = 0; i < apiTabs.length; i++) {
                tabs.push({
                    id: i,
                    route: `/stammdaten/${i}`,
                    name: apiTabs[i].LABEL,
                    icon: apiTabs[i].ICON,
                    gridName: apiTabs[i].GRIDNAME,
                    formName: apiTabs[i].FORMNAME,
                    multiSelectActions: apiTabs[i].MULTISELECTACTIONS,
                    context:"",
                })
            }

            return tabs;
            // const response = await axios.post(`${this.auth.getServiceUrl()}/Stammdaten/Stammdaten_GetGridList`, {
            //     SID: sid,
            //     UserId: user
            // });
            // if (response.data.Stammdaten_GetGridList_response?.ServiceErrors) {
            //     throw new Error(response.data.Stammdaten_GetGridList_response.ServiceErrors[0].ERRORRECOMMENDATION);
            // } else {
            //     const tabs = new Array();
            //     const apiTabs = response.data.Stammdaten_GetGridList_response;
            //     for (let i = 0; i < apiTabs.length; i++) {
            //         tabs.push({
            //             id: i,
            //             route: `/stammdaten/${i}`,
            //             name: apiTabs[i].LABEL,
            //             icon: apiTabs[i].ICON,
            //             gridName: apiTabs[i].GRIDNAME,
            //             formName: apiTabs[i].FORMNAME,
            //         })
            //     }
            //
            //     return tabs;
            }
        return [];
        }
}
